import { connect } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";

import { alreadyHaveACode } from "../../redux/actions/auth";
import { Button } from "../../component-library/Button";
import { CustomForm } from "../../component-library/CustomForm";
import FormikInput from "../UI/FormikInput";
import { Link } from "../../component-library";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../constants/aptihealth";
import { yup_password_factory } from "../../utils/yupSchemaUtils";

import { AuthWrapper } from "./index";

const emailValidationObject = {
  email: Yup.string().required("Email is required").email("Enter valid email id"),
};

const codeAndPassValidationObject = {
  confirmation_code: Yup.string().required("This field is required"),
  ConfirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("Password"), null], "Password does not match"),
  Password: yup_password_factory(),
};

const emailValidation = Yup.object().shape(emailValidationObject);

const codeAndPassValidation = Yup.object().shape(codeAndPassValidationObject);

const emailCodeAndPassValidation = Yup.object().shape({
  ...emailValidationObject,
  ...codeAndPassValidationObject,
});

const ChangePassword = (props) => {
  const hasEmail = props.hasEmail;

  const [pass, setPass] = useState("");
  const [passHasNum, setPassHasNum] = useState(false);
  const [passHasUpper, setPassHasUpper] = useState(false);
  const [passHasLower, setPassHasLower] = useState(false);
  const [passHasSpecial, setPassHasSpecial] = useState(false);
  const [passHasEightChars, setPassHasEightChars] = useState(false);

  const siftThroughEvents = (event) => {
    if (event.target.className.includes("is-password")) {
      setPass(event.target.value);
    }
  };

  useEffect(() => {
    setPassHasNum(/\d/.test(pass));
    setPassHasUpper(/[A-Z]/.test(pass));
    setPassHasLower(/[a-z]/.test(pass));
    setPassHasSpecial(/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(pass));
    setPassHasEightChars(pass.length >= 8);
  }, [pass]);

  return (
    <div>
      <h2 className="mb-4 reset-Pass-header">Reset your password</h2>
      <p style={{ color: "Gray", fontSize: "16px", textAlign: "center" }}>
        Enter the code you received in your email.
      </p>
      <CustomForm
        initialValues={{ confirmation_code: "", ConfirmPassword: "", Password: "" }}
        onSubmit={hasEmail ? props.setNewPassword : props.setNewPasswordWithEmail}
        render={(formikProps) => (
          <form onChange={(e) => siftThroughEvents(e)} onSubmit={formikProps.handleSubmit}>
            {!hasEmail && (
              <>
                <FormikInput
                  {...props.topFormikProps}
                  errors={formikProps.errors}
                  formEl={{
                    autocomplete: "off",
                    elementConfig: {
                      label: "Email",
                      labelClasses: "Forgot-PW-Input-Text",
                      placeholder: "Enter Email",
                      type: "text",
                    },
                    elementType: "input",
                    name: "email",
                  }}
                  touched={formikProps.touched}
                />
                <div style={{ marginBottom: "2rem" }}></div>
              </>
            )}
            <FormikInput
              {...props.topFormikProps}
              errors={formikProps.errors}
              formEl={{
                autocomplete: "off",
                elementConfig: {
                  label: "Reset Code",
                  labelClasses: "Forgot-PW-Input-Text",
                  placeholder: "Enter Reset Code",
                  type: "text",
                },
                elementType: "input",
                name: "confirmation_code",
              }}
              touched={formikProps.touched}
            />
            <div style={{ marginBottom: "2rem" }}></div>
            <div style={{ marginBottom: "1rem" }}>
              <FormikInput
                errors={formikProps.errors}
                touched={formikProps.touched}
                {...props.formikPasswordInputProps}
                formEl={{
                  elementConfig: {
                    label: "New Password",
                    labelClasses: "Forgot-PW-Input-Text",
                    placeholder: "Enter New Password",
                    type: "viewablePassword",
                  },
                  elementType: "input",
                  name: "Password",
                }}
              />
            </div>
            <p style={{ color: "Gray", fontSize: "12px", margin: "-5px 0 5px 0" }}>
              Password must have:
            </p>
            <ul style={{ marginBottom: "2em", marginLeft: "1em" }}>
              <li className={`${passHasNum ? "checked" : "unchecked"}`}>One number</li>
              <li className={`${passHasUpper ? "checked" : "unchecked"}`}>
                One uppercase character
              </li>
              <li className={`${passHasLower ? "checked" : "unchecked"}`}>
                One lowercase character
              </li>
              <li
                className={`${passHasSpecial ? "checked" : "unchecked"}`}
              >{`One special character ^ $ * . [ ] { } ( ) ? “ ! @ # % & /  , > < ${"'"} : ; | _ ~ ${"`"} = + -`}</li>
              <li className={`${passHasEightChars ? "checked" : "unchecked"}`}>
                Eight characters minimum
              </li>
            </ul>
            <FormikInput
              errors={formikProps.errors}
              touched={formikProps.touched}
              {...props.formikInputProps}
              formEl={{
                elementConfig: {
                  label: "Confirm New Password",
                  labelClasses: "Forgot-PW-Input-Text",
                  placeholder: "Confirm New Password",
                  type: "viewablePassword",
                },
                elementType: "input",
                name: "ConfirmPassword",
              }}
            />
            <div className="ResetPassword__submit-btn-wpr d-flex" style={{ marginTop: "1em" }}>
              <Button
                className="Btn Btn--pri Btn-sm mt-2 ml-auto"
                disabled={formikProps.isSubmitting}
                style={{ fontSize: "16px", margin: "0 auto" }}
                type="submit"
              >
                Reset Password
              </Button>
            </div>
            {!hasEmail && (
              <div
                style={{
                  color: "Gray",
                  fontSize: "14px",
                  marginTop: "2.5em",
                  textAlign: "center",
                }}
              >
                Didn't receive a reset code? Check your spam filter. <br /> If you're still having
                trouble, contact{" "}
                <a
                  className="has-reset-code"
                  href="mailto: support@aptihealth.com?subject=Web Support Request"
                >
                  support@aptihealth.com
                </a>{" "}
                for help.
              </div>
            )}
          </form>
        )}
        validationSchema={hasEmail ? codeAndPassValidation : emailCodeAndPassValidation}
      />
    </div>
  );
};

const ForgotPassword = (props) => {
  const {
    currentStep,
    emailFromPrevStep,
    sendResetPasswordCode,
    setNewPassword,
    setNewPasswordWithEmail,
  } = props;

  const [email, setEmail] = useState(emailFromPrevStep || "");
  const [validEmail, setValidEmail] = useState(false);
  const [hasCode, setHasCode] = useState(false);

  const email_schema = Yup.object({
    email: Yup.string().required().email(),
  });

  useEffect(() => {
    email_schema.isValid({ email }).then((valid) => setValidEmail(valid));
  }, [email]);

  let formikInputProps = {
    inputClasses: "Input--sm no-vert-padding",
  };

  let formikPasswordInputProps = {
    inputClasses: "Input--sm no-vert-padding is-password",
  };

  let sendResetCode = (
    <Fragment>
      <p className="login-welcome my-3">Forgot your password?</p>
      <p className="fs-16 mb-2 my-3" style={{ color: "gray", textAlign: "center" }}>
        Enter your email to receive a reset code. Note: You’ll need to have verified your email to
        complete the process.
      </p>
      <CustomForm
        initialValues={{ email: email }}
        onSubmit={sendResetPasswordCode}
        render={(formikProps) => (
          <form
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            onSubmit={formikProps.handleSubmit}
          >
            <div>
              <FormikInput
                errors={formikProps.errors}
                touched={formikProps.touched}
                {...formikInputProps}
                formEl={{
                  autocomplete: "off",
                  elementConfig: {
                    label: "Email",
                    labelClasses: "Forgot-PW-Input-Text",
                    placeholder: "Enter Email",
                    type: "email",
                  },
                  elementType: "input",
                  name: "email",
                }}
              />
            </div>
            <div className="ResetPassword__submit-btn-wpr d-flex tw:justify-center">
              <Button
                className={`Btn Btn--pri Btn-sm my-lg-5 my-3 ${
                  validEmail && email.length > 0 ? "primary" : "gray"
                }`}
                style={{ fontSize: "16px" }}
                type="submit"
              >
                Send Reset Code
              </Button>
            </div>
            <p
              className="has-reset-code"
              onClick={() => {
                if (!validEmail) {
                  setHasCode(true);
                }
                props.alreadyHaveACode(email);
              }}
            >
              Already Have a Code?
            </p>

            <p className="my-4 fs-14" style={{ color: "gray", textAlign: "center" }}>
              If you need help, contact support at{" "}
              <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
              <Link href={SUPPORT_NUMBER_HREF}>{SUPPORT_NUMBER}</Link>.
            </p>
          </form>
        )}
        validationSchema={emailValidation}
      />
    </Fragment>
  );
  const topFormikProps = {
    inputClasses: "Input--sm",
  };

  return (
    <AuthWrapper refFromOuter={props.scrlWprRef} showArt={props.showSvgArt} showBackLink={true}>
      <section className="ResetPassword">
        {currentStep === 1 && sendResetCode}
        {currentStep === 2 && (
          <ChangePassword
            hasEmail={!hasCode}
            setNewPassword={setNewPassword}
            setNewPasswordWithEmail={setNewPasswordWithEmail}
            topFormikProps={topFormikProps}
          />
        )}
      </section>
    </AuthWrapper>
  );
};

export default connect(null, { alreadyHaveACode })(ForgotPassword);
